/* eslint-disable */
import styles from './index.module.scss'
import { Link } from 'react-router-dom'

const Button = ({ children, to, version2 = false, click, top, style }) => {
  return (
    <Link
      style={{ marginTop: top + 'px', ...style }}
      to={to}
      onClick={click}
      className={`${styles.button} ${version2 ? styles.version2 : null}`}
    >
      {children}
    </Link>
  )
}

const FormButton = ({
  disabled,
  children,
  version2 = false,
  top,
  type,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      type={type}
      style={{
        marginTop: top + 'px',
        pointerEvents: disabled ? 'none' : 'all',
        border: 'none',
        backgroundColor: disabled ? '#BDBDBD' : '#166FE5',
      }}
      className={`${styles.button} ${version2 ? styles.version2 : null}`}
    >
      {children}
    </button>
  )
}
export { Button, FormButton }
